import RepairOrderResponse from 'src/adminPanel/entities/service/RepairOrderResponse';
import { action } from 'src/store/actions';

export const FETCH_REPAIR_ORDERS = 'FETCH_REPAIR_ORDERS';
export const REQUEST_REPAIR_ORDERS = 'REQUEST_REPAIR_ORDERS';
export const SUCCESS_REPAIR_ORDERS = 'SUCCESS_REPAIR_ORDERS';
export const FAILURE_REPAIR_ORDERS = 'FAILURE_REPAIR_ORDERS';
export const SUBMIT_FINISH_REPAIR_ORDER = 'SUBMIT_FINISH_REPAIR_ORDER';
export const SUCCESS_FINISH_REPAIR_ORDER = 'SUCCESS_FINISH_REPAIR_ORDER';

export const fetchRepairOrders = () => action(FETCH_REPAIR_ORDERS);
export const requestRepairOrders = () => action(REQUEST_REPAIR_ORDERS);
export const requestRepairOrdersSuccess = (response: any) => action(SUCCESS_REPAIR_ORDERS, { response });
export const requestRepairOrdersFailure = (error: any) => action(FAILURE_REPAIR_ORDERS, { error });

export const submitFinishRepairOrder = (claimId: string, data: RepairOrderResponse) =>
    action(SUBMIT_FINISH_REPAIR_ORDER, { claimId, data });
export const requestFinishRepairOrderSuccess = () => action(SUCCESS_FINISH_REPAIR_ORDER);
